import {
  ProductWithSupplier,
  GlobalProduct,
  GlobalSupplier,
  Supplier,
  CUSTOM_PRODUCT_ID,
  CUSTOM_SUPPLIER_ID,
} from '@omnea-app/products/productsFrontendClient'

export type SupplierHitType = {
  id: string
  name: string
  type: 'SUPPLIER' | 'GLOBAL_SUPPLIER' | 'NEW_SUPPLIER'
  isPreferred?: boolean
  logoUrl?: string | null
  legalName?: string | null
  remoteLink?: string | null
  remoteType?: string | null
  subsidiaries?: { id: string; name: string }[]
}

export type ProductHitType = {
  id: string
  name: string
  type: 'PRODUCT' | 'GLOBAL_PRODUCT' | 'NEW_PRODUCT'
  supplier?: SupplierHitType
  logoUrl?: string | null
}

export type HitType = SupplierHitType | ProductHitType

export const isSupplierOption = (selectedOption: HitType): selectedOption is SupplierHitType => {
  return selectedOption.type === 'SUPPLIER' || selectedOption.type === 'NEW_SUPPLIER' || selectedOption.type === 'GLOBAL_SUPPLIER'
}

export type SupplierOptionType = Supplier | GlobalSupplier | NewSupplier
export type ProductOptionType = ProductWithSupplier | GlobalProduct | NewProduct

export const isNewProduct = (value: any): value is NewProduct => {
  return 'type' in value && value.type === 'NEW_PRODUCT' && value.id === CUSTOM_PRODUCT_ID
}
export const isNewSupplier = (value: any): value is NewSupplier => {
  return 'type' in value && value.type === 'NEW_SUPPLIER' && value.id === CUSTOM_SUPPLIER_ID
}
export const isSupplier = (option: ProductOptionType | SupplierOptionType): option is Supplier | GlobalSupplier | NewSupplier => {
  return option.type === 'SUPPLIER' || option.type === 'GLOBAL_SUPPLIER'
}
export const isOrgSupplier = (option: ProductOptionType | SupplierOptionType): option is Supplier => {
  return option.type === 'SUPPLIER'
}

export type NewSupplier = { id: typeof CUSTOM_SUPPLIER_ID; name: string; type: 'NEW_SUPPLIER'; isPreferred: false; logoUrl: null }
export type NewProduct = { id: typeof CUSTOM_PRODUCT_ID; name: string; type: 'NEW_PRODUCT' }

export interface EditMode {
  supplier: 'editable' | 'read-only'
  product: 'editable' | 'read-only' | 'hidden'
  contact: 'editable' | 'read-only'
}
